// extracted by mini-css-extract-plugin
var _1 = "EmailsRecipients-modulefield__EBfeo";
var _2 = "EmailsRecipients-modulelabel__tqH5y";
export { _1 as "field", _2 as "label" }
